// @flow
import React from "react";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";

import { actionCreators } from "./index";
// Import CSS modules first to establish consistent load order
import styles from "./ResetPassword.module.css";
import formStyles from "../components/Form.module.css";
// Then import components
// $FlowIgnore
import Input from "../components/Input";
// $FlowIgnore TS import
import RawFormattedMessage from "../components/RawFormattedMessage";
import type { State } from "../store/reducer";
// $FlowIgnore TS import
import type { Action } from "../../types/Action";

type ResetPasswordProps = {
  loadResetPassword: typeof actionCreators.loadResetPassword,
  intl: any,
};

export const ResetPassword = ({
  loadResetPassword,
  intl,
}: ResetPasswordProps) => (
  <div className={styles.container}>
    <section className={styles.root}>
      <header>
        <RawFormattedMessage tagName="h4" id="reset-password.title" />
        <p className={formStyles.description}>
          <FormattedMessage id="reset-password.description" />
        </p>
      </header>
      <form
        className={formStyles.root}
        onSubmit={(e) => {
          e.preventDefault();
          loadResetPassword();
        }}
      >
        <Input
          data-qa="email"
          id="email"
          /* $FlowIgnore */
          label={intl.formatMessage({ id: "shared.email" })}
          required
          type="email"
        />
        <button type="submit" data-qa="reset-password">
          <FormattedMessage id="reset-password.cta" />
        </button>
      </form>
    </section>
  </div>
);

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default compose(
  injectIntl,
  connect(null, mapDispatchToProps),
)(ResetPassword);
